import React, { useState, useEffect } from 'react';
import { Search, CheckCircle2, User, Trash2 } from 'lucide-react'; // Trash2 import kiya
import Swal from 'sweetalert2'; // Swal import kiya

const CustomerManagement: React.FC = () => {
  const [customers, setCustomers] = useState<any[]>([]);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    fetchCustomers();
  }, []);

  const fetchCustomers = async () => {
    try {
      const response = await fetch('https://motilalalgo.com/api/admin/customers');
      const data = await response.json();
      if (data.success) setCustomers(data.users);
    } catch (error) {
      console.error("Failed to fetch customers", error);
    }
  };

  // Delete Function
  const handleDelete = async (userId: number) => {
    Swal.fire({
      title: 'Are you sure?',
      text: "This user will be permanently deleted from the database!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#ef4444',
      cancelButtonColor: '#94a3b8',
      confirmButtonText: 'Yes, delete it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await fetch(`https://motilalalgo.com/api/admin/customer/${userId}`, {
          // const response = await fetch(`http://localhost:10001/api/admin/customer/${userId}`, {
            method: 'DELETE'
          });
          const data = await response.json();
          
          if (data.success) {
            Swal.fire('Deleted!', 'Customer has been deleted.', 'success');
            // State update karke deleted user ko table se hata do
            setCustomers(customers.filter(c => c.id !== userId));
          } else {
            Swal.fire('Error!', data.error, 'error');
          }
        } catch (error) {
          Swal.fire('Error!', 'Server connection failed', 'error');
        }
      }
    });
  };

  const filteredCustomers = customers.filter(c => 
    c.first_name.toLowerCase().includes(searchTerm.toLowerCase()) || 
    c.mobile_number.includes(searchTerm) ||
    c.email.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="max-w-[1600px] mx-auto space-y-6">
      
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 bg-white p-6 rounded-2xl shadow-sm border border-slate-100">
        <div>
          <h1 className="text-2xl font-black text-slate-800">Customer Management</h1>
          <p className="text-sm text-slate-500 mt-1">View and manage all registered platform users.</p>
        </div>
        
        <div className="relative w-full sm:w-80">
          <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" size={18} />
          <input 
            type="text" 
            placeholder="Search by name, email or mobile..." 
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pl-11 pr-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-sm font-medium focus:ring-2 focus:ring-[#3b36a4]/20 focus:border-[#3b36a4] outline-none transition-all"
          />
        </div>
      </div>

      <div className="bg-white border border-slate-100 rounded-2xl shadow-sm overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-left border-collapse whitespace-nowrap min-w-[1000px]">
            <thead>
              <tr className="bg-slate-50/50 text-xs uppercase tracking-widest text-slate-400 font-bold border-b border-slate-100">
                <th className="px-6 py-4">User Details</th>
                <th className="px-6 py-4">Contact Info</th>
                <th className="px-6 py-4">Documents</th>
                <th className="px-6 py-4">Credentials</th>
                <th className="px-6 py-4">Status</th>
                <th className="px-6 py-4 text-right">Action</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-50">
              {filteredCustomers.map((user) => (
                <tr key={user.id} className="hover:bg-slate-50/50 transition-colors">
                  <td className="px-6 py-4">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-full bg-indigo-50 text-indigo-600 flex items-center justify-center font-bold">
                        <User size={18} />
                      </div>
                      <div>
                        <div className="font-bold text-slate-800">{user.first_name} {user.last_name}</div>
                        <div className="text-xs font-semibold text-slate-400 mt-0.5">Joined: {new Date(user.created_at).toLocaleDateString()}</div>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4">
                    <div className="font-bold text-slate-700 text-sm">{user.mobile_number}</div>
                    <div className="text-xs font-medium text-slate-400 mt-0.5">{user.email}</div>
                  </td>
                  <td className="px-6 py-4">
                    <div className="flex flex-col items-start gap-1.5">
                      <span className="text-[11px] font-bold text-slate-500">Aadhar: <span className="text-slate-800">{user.aadhar_no}</span></span>
                      <span className="text-[11px] font-bold text-slate-500">PAN: <span className="text-slate-800">{user.pan_no}</span></span>
                    </div>
                  </td>
                  <td className="px-6 py-4">
                    {user.login_id ? (
                       <div className="flex flex-col items-start gap-1">
                          <span className="text-xs font-bold text-emerald-600 bg-emerald-50 px-2 py-0.5 rounded border border-emerald-100">ID: {user.login_id}</span>
                          <span className="text-xs font-bold text-slate-500 bg-slate-100 px-2 py-0.5 rounded border border-slate-200">Pass: {user.raw_password}</span>
                       </div>
                    ) : (
                       <span className="text-xs text-slate-400 italic">Not Assigned</span>
                    )}
                  </td>
                  <td className="px-6 py-4">
                    {user.login_id ? (
                      <span className="inline-flex items-center gap-1.5 py-1.5 px-3 rounded-full bg-emerald-50 text-emerald-600 text-xs font-bold">
                        <CheckCircle2 size={14} /> Active
                      </span>
                    ) : (
                      <span className="inline-flex items-center gap-1.5 py-1.5 px-3 rounded-full bg-amber-50 text-amber-600 text-xs font-bold">
                        <span className="w-1.5 h-1.5 rounded-full bg-amber-500 animate-pulse"></span> Pending
                      </span>
                    )}
                  </td>
                  <td className="px-6 py-4 text-right">
                    <div className="flex justify-end items-center gap-2">
                      <button 
                        onClick={() => window.location.href = `/moti-lal/customer/${user.id}`} 
                        className="inline-flex items-center justify-center px-4 py-2 bg-indigo-50 text-[#3b36a4] font-bold text-xs rounded-xl hover:bg-[#3b36a4] hover:text-white transition-colors border border-indigo-100 shadow-sm"
                      >
                        View Profile
                      </button>
                      <button 
                        onClick={() => handleDelete(user.id)} 
                        className="inline-flex items-center justify-center p-2 bg-red-50 text-red-500 font-bold text-xs rounded-xl hover:bg-red-500 hover:text-white transition-colors border border-red-100 shadow-sm"
                        title="Delete User"
                      >
                        <Trash2 size={16} />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
              {filteredCustomers.length === 0 && (
                <tr><td colSpan={6} className="text-center py-10 text-slate-400 font-medium">No customers found.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default CustomerManagement;